import { ReactNode } from "react";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@src/components/ui/card";
import { cn } from "@lib/utils/ui";
type AuthCardProps = {
  title: string;
  description?: string;
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
};
export function AuthCard({
  title,
  description,
  children,
  footer,
  className
}: AuthCardProps) {
  return <Card className={cn("w-full", className)} data-sentry-element="Card" data-sentry-component="AuthCard" data-sentry-source-file="AuthCard.tsx">
      <CardHeader data-sentry-element="CardHeader" data-sentry-source-file="AuthCard.tsx">
        <CardTitle className="text-2xl font-bold" data-sentry-element="CardTitle" data-sentry-source-file="AuthCard.tsx">{title}</CardTitle>
        {description && <CardDescription>{description}</CardDescription>}
      </CardHeader>
      <CardContent data-sentry-element="CardContent" data-sentry-source-file="AuthCard.tsx">
        {children}
      </CardContent>
      {footer && <CardFooter className="flex justify-center border-t pt-6">
          {footer}
        </CardFooter>}
    </Card>;
}